"use strict";
// shared-utils-lib/src/formatting/ResponseFormatter.ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponseFormatter = void 0;
class ResponseFormatter {
    /**
     * Format successful response
     */
    static success(data, metadata) {
        return {
            success: true,
            data,
            ...(metadata && { metadata }),
            timestamp: new Date().toISOString()
        };
    }
    /**
     * Format error response
     */
    static error(message, code = 'INTERNAL_ERROR', details, requestId) {
        return {
            success: false,
            error: {
                message,
                code,
                ...(details && { details }),
                ...(requestId && { requestId })
            },
            timestamp: new Date().toISOString()
        };
    }
    /**
     * Format paginated response
     */
    static paginated(data, total, page, limit) {
        const pages = Math.ceil(total / limit) || 1;
        return this.success(data, {
            pagination: {
                total,
                page,
                limit,
                pages,
                hasNext: page < pages,
                hasPrev: page > 1
            }
        });
    }
    /**
     * Check if response is success
     */
    static isSuccess(response) {
        return response.success === true;
    }
    /**
     * Check if response is error
     */
    static isError(response) {
        return response.success === false;
    }
}
exports.ResponseFormatter = ResponseFormatter;
